import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard, noAuthGuard } from './guards/auth/auth.guard';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then((module) => module.AuthModule),
    canActivate: [noAuthGuard],
  },
  {
    path: 'users-tables',
    loadChildren: () => import('./users-tables/users-table.module').then((module) => module.UsersTableModule),
    canActivate: [authGuard],
  },
  {
    path: 'events',
    loadChildren: () => import('./events/events.module').then((module) => module.EventsModule),
    canActivate: [authGuard],
  },
  {
    path: 'bookings',
    loadChildren: () => import('./bookings/bookings.module').then((module) => module.BookingsModule),
  },
  {
    path: 'profiles',
    loadChildren: () => import('./profiles/profiles.module').then((module) => module.ProfilesModule),
  },
  {
    path: 'privacy',
    loadChildren: () => import('./privacy/privacy.module').then((module) => module.PrivacyModule),
  },
  {
    path: 'termsAndConditions',
    loadChildren: () => import('./terms-and-conditions/terms-and-conditions.module').then((module) => module.TermsAndConditionsModule),
  },
  {
    path: 'configuration',
    loadChildren: () => import('./configuration/configuration.module').then((module) => module.ConfigurationModule),
  },
  {
    path: '',
    redirectTo: '/events',
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: '/events'
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
